import { skipToken, useQuery } from '@tanstack/react-query';
import { oauthClientsApi } from '@/features/settings/oauth-clients/api';
import { oauthClientsQueryKeys } from '@/features/settings/oauth-clients/queryKeys';

export const useOauthClientsQuery = () =>
  useQuery({
    queryKey: oauthClientsQueryKeys.list(),
    queryFn: () => oauthClientsApi.list(),
  });

export const getOauthClientQueryOptions = (id: string) => ({
  queryKey: oauthClientsQueryKeys.detail(id),
  queryFn: () => oauthClientsApi.get(id),
});

export const useOauthClientQuery = (id: string | null) =>
  useQuery({
    queryKey: id !== null ? oauthClientsQueryKeys.detail(id) : oauthClientsQueryKeys.all(),
    queryFn: id !== null ? () => oauthClientsApi.get(id) : skipToken,
  });
